module.exports = __webpack_public_path__ + "img/ic24ContractBlack.98be2ee8.svg";